import React, { FunctionComponent } from 'react';

import useCountryData from '../hooks/useCountryData';

const FormattedCountryName: FunctionComponent<{
  code?: string | null;
}> = ({ code }) => {
  const { data } = useCountryData(code);

  return <>{data?.fullNameLocale || code}</>;
};

export default FormattedCountryName;
